module.exports = __webpack_public_path__ + "img/titan-default.a840c8a5.jpg";